var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"suscrip-diarios\">\r\n    <div class=\"suscrip-diarios__titulo\">\r\n        <hr>\r\n        <h3>O bien al diario y las revistas impresas</h3>\r\n        <hr>\r\n    </div>\r\n    <div class=\"suscrip-diarios__caja\">\r\n        <div class=\"suscrip-diarios__caja__img\"></div>\r\n        <h4><strong>SUSCRIBITE A DIARIOS Y REVISTAS.</strong> Recibí los productos en tu casa.</h4>        \r\n        <button class=\"btn-principal next-button\" type=\"button\" data-step=\"redirect\" data-url=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Constantes : depth0)) != null ? stack1.Dominios : stack1)) != null ? stack1.miclub : stack1), depth0))
    + "\">Suscribite</button>\r\n    </div>\r\n</div>\r\n\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/suscripcion_diario.hbs
// module id = 505
// module chunks = 0 1